module.exports = __webpack_public_path__ + "img/deckbuild_default.696cf06e.jpg";